import React from 'react'

import ImageSkeleton from '../../../shared_components/Svg/ImageSkeleton'

const CardPreviewSkeleton = () => {
  return (
    <div className='CardPreviewSkeleton'>
      <div className='CardPreviewSkeleton-imageWrapper'>
        <ImageSkeleton />
      </div>
      <div className='CardPreviewSkeleton-contentWrapper'>
        <div className='CardPreviewSkeleton-first'/>
        <div className='CardPreviewSkeleton-second'>
          <div className='CardPreviewSkeleton-second--item' />
          <div className='CardPreviewSkeleton-second--item' />
          <div className='CardPreviewSkeleton-second--item' />
          <div className='CardPreviewSkeleton-second--item' />
        </div>
        <div className='CardPreviewSkeleton-third'/>
        <div className='CardPreviewSkeleton-fourth'/>
      </div>
    </div>
  )
}

export default CardPreviewSkeleton
